// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3JMFp","additionalInfo":"AgreementModal_additionalInfo__2OfmU"};